// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/articoli/:id/storico-prezzi',
    requestBody: null,
    response: '{"success":true,"data":{"articolo":{"id":"number","codice":"string","descrizioneBase":"string","prezzoStandard":"string|null","prezzoListinoVendita":"string|null","convertitore":"string","umVendita":"object|null","umAcquisto":"object|null","fornitore":"object|null","ultimoImport":"object|null","updatedAt":"string"},"righe":[{"id":"number","importListinoId":"number","prezzoStandard":"string","stato":"string","importListino":"object"}],"riepilogo":{"nRighe":"number","nRigheApplicate":"number","nImport":"number","nFornitori":"number","primoImportAt":"string|null","ultimoImportAt":"string|null","prezzoMin":"number|null","prezzoMax":"number|null"}}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
